import Invitation from "@/types/Invitation.interface"

interface State {
    invitations: Invitation[]
}

const defaults = () => {
    return {
        invitations: []
    }
}

export default {
    state: defaults(),
    mutations: {
        invitationsPush (state: State, invitations: Invitation[]): void {
            state.invitations = window.removeDuplicatesById(state.invitations, invitations)
        },
        invitationsRemove (state: State, ids: number[]): void {
            //  Get the global list of invitations
            const invitations = state.invitations

            //  If no invitations, do nothing
            if (!invitations) return

            //  Else, filter out our removed ids
            const filtered = invitations.filter((x: Invitation) => !ids.includes(x.id))

            //  Replace our invitations list with the filtered list
            state.invitations = filtered
        },
        invitationsSet (state: State, invitations: Invitation[]): void {
            state.invitations = invitations
        },
        invitationsReset (state: State): void {
            Object.assign(state, defaults())
        }
    },
    actions: {
        invitationCancel ({ commit, getters }, invitationId: number): Promise<Invitation> {
            //  Assemble the API endpoint
            const url = `${getters.api}/invitations/${invitationId}`

            //  Send the request
            return window.axios.delete(url).then(response => {
                //  Remove the invitation from the global list
                commit('invitationsRemove', [response.data.id])

                //  Remove the invitation from the users view list
                commit('teammatesInvitationsRemove', [response.data.id])

                //  Return the deleted invitation
                return response.data
            }).catch(() => null)
        },
        invitationsGet ({ commit, getters }): Promise<Invitation> {
            //  Assemble the API endpoint
            const url = `${getters.api}/invitations`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Set our global invitations list
                commit('invitationsSet', response.data)

                //  Set our users view invitations list
                commit('teammatesInvitationsSet', response.data)

                //  Return the invitations list
                return response.data
            }).catch(() => null)
        },
        invitationsFind ({ getters }, invitationId: number): Promise<Invitation> {
            //  Assemble the API endpoint
            const url = `${getters.api}/invitations/${invitationId}`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Return the found invitation
                return response.data
            }).catch(() => null)
        },
        invitationResend ({ commit, getters }, invitation: Invitation): Promise<Invitation> {
            //  Assemble the API endpoint
            const url = `${getters.api}/invitations`

            //  Send the request
            return window.axios.put(url, invitation).then(response => {
                //  Update our invitations list
                commit('invitationsPush', [response.data])

                //  Update our users view invitations list
                commit('teammatesInvitationsPush', [response.data])

                //  Return the updated invitation
                return response.data
            }).catch(() => null)
        },
        invitationSend ({ commit, getters }, invitation: Invitation): Promise<Invitation> {
            //  Assemble the API endpoint
            const url = `${getters.api}/invitations`

            //  Send the request
            return window.axios.post(url, invitation).then(response => {
                //  Update our invitations list
                commit('invitationsPush', [response.data.data])

                //  Update our users view invitations list
                commit('teammatesInvitationsPush', [response.data.data])

                //  Return the sent invitation
                return response.data
            }).catch(() => null)
        }
    },
    getters: {
        invitations (state: State): Invitation[] {
            return state.invitations
        }
    }
}